import {Injectable} from '@angular/core';
import {
  IResourceMethod, Resource,
  ResourceAction,
  ResourceHandler,
  ResourceParams,
  ResourceRequestMethod
} from '@ngx-resource/core';
import {ResourceAuth} from '../../common.module/auth/authenticate.resource';
import {AuthServerProvider} from '../../common.module/auth/auth-jwt.service';
import {PersonaBoletinadaModel} from './persona-boletinada.model';
import { ControlTarjetas } from 'src/app/admin.control-tarjetas.module/models/controlTarjetas.model';

@Injectable()
@ResourceParams({
    pathPrefix: '/tramites'
    //url: 'http://localhost:8013'
})
export class PersonaBoletinadaResource extends ResourceAuth{
    constructor(resourceHandler: ResourceHandler, authProv: AuthServerProvider){
        super(resourceHandler, authProv);
    }
    /*
    export class PersonaBoletinadaResource extends Resource {
    constructor(resourceHandler: ResourceHandler) {
        super(resourceHandler);
    }
*/
    @ResourceAction({
        path: '/persona-boletinada',
        method: ResourceRequestMethod.Get
    })
    obtenerListadoPersonasBoletinadas : IResourceMethod<PersonaBoletinadaModel[], any>

    @ResourceAction({
        path: '/persona-boletinada/{!_id}',
        method: ResourceRequestMethod.Get
    })
    obtenerPersonaBoletinada:IResourceMethod<{ _id: any }, PersonaBoletinadaModel>
    
    @ResourceAction({
        path: '/persona-boletinada/{!usuario_curp}/curp',
        method: ResourceRequestMethod.Get
    })
    obtenerPersonaPorCurp:IResourceMethod<{usuario_curp: any }, PersonaBoletinadaModel>

    @ResourceAction({
        path: '/persona-boletinada/{!_id}',
        method: ResourceRequestMethod.Delete
    })
    eliminarPersonaBoletinada:IResourceMethod<{ _id: any }, any>

    @ResourceAction({
        path: '/buscar-persona-folio/{!folio}',
        method: ResourceRequestMethod.Get
    })
    obtenerPersonaPorFolioTia:IResourceMethod<{folio:any},ControlTarjetas>

    @ResourceAction({
        path:"/persona-boletinada",
        method: ResourceRequestMethod.Post,
    })
    agregarPersonaBoletinada:IResourceMethod<PersonaBoletinadaModel,any>
    
    @ResourceAction({
        path:"/persona-boletinada/{!_id}",
        method:ResourceRequestMethod.Patch
    })
    actualizarPersonaBoletinada:IResourceMethod<PersonaBoletinadaModel,any>

    
}